import * as React from 'react';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { Text } from '@audi/audi-ui-react-v2';
import { CoreCiIcon } from '..';
import { messages } from '../../i18n/messages';
const Icon = styled.div `
  display: flex;
  justify-content: center;
  margin-bottom: var(${(props) => props.theme.responsive.spacing.s});
`;
export const Button = styled.button `
  margin-bottom: var(${(props) => props.theme.responsive.spacing.xxl});
  margin-top: ${(props) => props.buttonPosition === 'bottom' && props.isExpanded
    ? `var(${props.theme.responsive.spacing.xxl})`
    : '0'};
  order: 1;
  background: transparent;
  border: 0;
`;
export const ExpandableButton = ({ isExpanded, onExpandHandler, buttonPosition, i18n, }) => {
    const lessLabel = i18n ? i18n.lessLabel : useI18n(messages.expandable.button.lessLabel);
    const moreLabel = i18n ? i18n.moreLabel : useI18n(messages.expandable.button.moreLabel);
    return (React.createElement(Button, { isExpanded: isExpanded, buttonPosition: buttonPosition, onClick: onExpandHandler, "data-testid": "expandableBtn" },
        React.createElement(Icon, null,
            React.createElement(CoreCiIcon, { icon: "add-large", size: "large", rotation: isExpanded ? '45' : '0' })),
        React.createElement("p", null,
            React.createElement(Text, { variant: "copy1", as: "span" }, isExpanded ? lessLabel : moreLabel))));
};
